import React from "react";
import { Video } from "lucide-react";

const fmt = (v) => (v === null || v === undefined ? "—" : `${v}%`);

const Column = ({ title, o, tone, testid }) => (
  <div className={`border p-4 ${tone}`} style={{ borderRadius: 0 }} data-testid={testid}>
    <div className="text-[10px] tracking-[0.16em] uppercase text-zinc-400">{title}</div>
    <div className="font-serif-display text-3xl text-white mt-1">{o.leads}</div>
    <div className="text-[11px] text-zinc-500">leads</div>
    <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
      <div><div className="text-zinc-500">Show-up</div><div className="text-white text-base">{fmt(o.show_rate)}</div><div className="text-[10px] text-zinc-600">{o.showed} showed · {o.no_show} no-show</div></div>
      <div><div className="text-zinc-500">Close</div><div className="text-white text-base">{fmt(o.close_rate)}</div><div className="text-[10px] text-zinc-600">{o.closed} of {o.showed} closed</div></div>
    </div>
  </div>
);

function insight(v) {
  const a = v.watched, b = v.not_watched;
  if (a.show_rate === null || b.show_rate === null) return "Not enough completed calls yet to compare. Keep marking calls as Completed / No-Show in Bookings.";
  const diff = Math.round(a.show_rate - b.show_rate);
  if (diff >= 10) return `Leads who opened the video show up ${diff} pts more often. Push the video harder in nurture.`;
  if (diff <= -10) return `Leads who opened the video show up ${Math.abs(diff)} pts less often. Revisit the video's message.`;
  return "Show-up rates are similar for both groups so far. The video isn't moving show-ups much yet.";
}

export const PrecallVideoCard = ({ data }) => {
  if (!data) return null;
  const openRate = data.sent ? Math.round((100 * data.opened) / data.sent) : 0;
  return (
    <div className="luxury-card p-6 mb-6" data-testid="funnel-precall-video">
      <div className="eyebrow flex items-center gap-1.5 mb-1"><Video size={12} className="text-red-500" /> 04 The Nurture · Pre-call video</div>
      <p className="text-xs c-muted mb-4">Does watching Saurabh's video change who shows up and who closes?</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {[["Link sent", data.sent], ["Opened", `${data.opened} · ${openRate}%`], ["Watched 75%+", data.watched_75], ["Nudged (unwatched)", data.nudged]].map(([l, v]) => (
          <div key={l} className="border border-white/10 bg-black/30 p-3" style={{ borderRadius: 0 }} data-testid={`precall-stat-${l.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <div className="text-[10px] tracking-[0.14em] uppercase text-zinc-500">{l}</div>
            <div className="text-xl text-white mt-1">{v}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Column title="Opened the video" o={data.watched} tone="border-emerald-800/50 bg-emerald-950/10" testid="precall-watched" />
        <Column title="Didn't open" o={data.not_watched} tone="border-white/10 bg-black/30" testid="precall-not-watched" />
      </div>
      <div className="mt-4 border-l-2 border-red-600 pl-3 text-sm text-zinc-300" data-testid="precall-insight">{insight(data)}</div>
    </div>
  );
};
